(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-image-carousel"] && !Shopify.designMode) return;
  try {
    
  function initAboutCarouselAutoplay() {
    document.querySelectorAll('[data-testid="about-image-carousel"][data-autoplay="true"]').forEach(function (section) {
      if (section.dataset.autoplayInit) return;
      var carousel = section.querySelector('slideshow-component');
      if (!carousel) return;
      section.dataset.autoplayInit = 'true';

      var speed = (parseFloat(section.dataset.autoplaySpeed) || 3) * 1000;

      setInterval(function () {
        if (carousel.matches(':hover') || document.hidden) return;
        var slides = carousel.slides;
        if (!slides || !slides.length) return;
        var next = (carousel.current + 1) % slides.length;
        carousel.select(next);
      }, speed);
    });
  }
  window.addEventListener('load', initAboutCarouselAutoplay);
  document.addEventListener('shopify:section:load', initAboutCarouselAutoplay);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["discover-the-series"] && !Shopify.designMode) return;
  try {
    
  function initDiscoverSeriesReveal() {
    var cards = document.querySelectorAll('[data-series-card]:not([data-reveal-init])');
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    cards.forEach(function (card) {
      card.dataset.revealInit = 'true';

      if (canHover && card.querySelector('.series-card__image--hover')) {
        card.addEventListener('mouseenter', function () {
          card.classList.add('is-revealed');
        });
        card.addEventListener('mouseleave', function () {
          card.classList.remove('is-revealed');
        });
      }
    });
  }
  window.addEventListener('load', initDiscoverSeriesReveal);
  document.addEventListener('shopify:section:load', initDiscoverSeriesReveal);

  function initSeriesZoomBlurOnClose() {
    var section = document.querySelector('[data-testid="discover-the-series"]:not([data-zoom-blur-init])');
    if (!section) return;
    section.dataset.zoomBlurInit = 'true';

    section.addEventListener('focusin', function (event) {
      var target = event.target;
      if (target && target.tagName === 'SLIDESHOW-SLIDES' && typeof target.blur === 'function') {
        target.blur();
      }
    });
  }
  window.addEventListener('load', initSeriesZoomBlurOnClose);
  document.addEventListener('shopify:section:load', initSeriesZoomBlurOnClose);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  function initProductListAutoplay() {
    document.querySelectorAll('[data-testid="product-list"][data-autoplay="true"]').forEach(function (section) {
      if (section.dataset.autoplayInit) return;
      var carousel = section.querySelector('slideshow-component');
      if (!carousel) return;
      section.dataset.autoplayInit = 'true';

      var speed = (parseFloat(section.dataset.autoplaySpeed) || 3) * 1000;

      // `:hover` never applies on touch devices, so without this the autoplay timer
      // kept firing carousel.select() mid-swipe on mobile, fighting the user's own
      // drag and making slides jump/highlight on their own.
      var touching = false;
      var resumeTimeout;
      carousel.addEventListener(
        'touchstart',
        function () {
          touching = true;
          clearTimeout(resumeTimeout);
        },
        { passive: true }
      );
      ['touchend', 'touchcancel'].forEach(function (type) {
        carousel.addEventListener(
          type,
          function () {
            clearTimeout(resumeTimeout);
            resumeTimeout = setTimeout(function () {
              touching = false;
            }, speed);
          },
          { passive: true }
        );
      });

      setInterval(function () {
        // On mobile the carousel is driven entirely by the user's own swipe/tap —
        // autoplay was jumping it to the next product on its own, so it's disabled
        // below this breakpoint and only ever advances here on desktop.
        if (window.matchMedia('(max-width: 749px)').matches) return;
        if (touching || carousel.matches(':hover') || document.hidden) return;
        var slides = carousel.slides;
        if (!slides || !slides.length) return;
        var next = (carousel.current + 1) % slides.length;
        carousel.select(next);
      }, speed);
    });
  }
  window.addEventListener('load', initProductListAutoplay);
  document.addEventListener('shopify:section:load', initProductListAutoplay);

  function initClickToPreviewImage() {
    document.querySelectorAll('[data-testid="product-list"][data-click-to-preview="true"]').forEach(function (section) {
      if (section.dataset.clickPreviewInit) return;
      section.dataset.clickPreviewInit = 'true';

      // The theme's built-in hover-to-preview only fires for mouse pointers, so blocking
      // pointerenter/pointerleave in the capture phase (before it reaches .card-gallery)
      // disables it just within this section, without touching the global setting.
      ['pointerenter', 'pointerleave'].forEach(function (type) {
        section.addEventListener(
          type,
          function (event) {
            if (event.target.closest('.card-gallery')) {
              event.stopImmediatePropagation();
            }
          },
          true
        );
      });

      // The outer carousel implements its own drag-to-swipe (not native scroll), so
      // browsers don't suppress the trailing click the way they do after a native
      // touch-scroll. Without this, swiping past a card can fire a stray click on
      // whatever it released over, wrongly triggering the preview below. Track the
      // pointer's start position and only treat it as a tap if it barely moved.
      var pointerDownPos = null;
      section.addEventListener(
        'pointerdown',
        function (event) {
          pointerDownPos = { x: event.clientX, y: event.clientY };
        },
        true
      );

      var TAP_MOVE_THRESHOLD = 10;

      // Reveal the second image on click instead, without navigating away.
      //
      // We swap the visible <img>'s src/srcset directly rather than calling the
      // slideshow-component's own select()/next(), because inside a carousel layout
      // each card's gallery is a *nested* slideshow, which the component permanently
      // disables (see slideshow.js `isNested`) to avoid conflicting drag/scroll
      // gestures — that also silently makes the built-in hover-preview a no-op here.
      section.addEventListener('click', function (event) {
        if (pointerDownPos) {
          var dx = Math.abs(event.clientX - pointerDownPos.x);
          var dy = Math.abs(event.clientY - pointerDownPos.y);
          pointerDownPos = null;
          if (dx > TAP_MOVE_THRESHOLD || dy > TAP_MOVE_THRESHOLD) return;
        }

        var link = event.target.closest('[ref="cardGalleryLink"]');
        if (!link) return;

        var gallery = link.closest('.card-gallery');
        if (!gallery || gallery.dataset.previewShown === 'true') return;

        var images = gallery.querySelectorAll('slideshow-slide img');
        if (images.length < 2) return;

        event.preventDefault();
        var current = images[0];
        var next = images[1];
        current.src = next.currentSrc || next.src;
        if (next.srcset) current.srcset = next.srcset;
        if (next.sizes) current.sizes = next.sizes;
        gallery.dataset.previewShown = 'true';
      });
    });
  }
  window.addEventListener('load', initClickToPreviewImage);
  document.addEventListener('shopify:section:load', initClickToPreviewImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-popup"] && !Shopify.designMode) return;
  try {
    
  function initWelcomePopup() {
    var popup = document.querySelector('[data-testid="welcome-popup"]');
    if (!popup || popup.dataset.popupBound) return;
    popup.dataset.popupBound = 'true';

    var storageKey = 'uchi-welcome-popup-seen';
    if (sessionStorage.getItem(storageKey)) return;

    var delay = parseInt(popup.dataset.delay, 10) || 0;

    function closePopup() {
      popup.classList.remove('is-visible');
      sessionStorage.setItem(storageKey, 'true');
    }

    var backdrop = popup.querySelector('[data-welcome-popup-backdrop]');
    var closeButton = popup.querySelector('[data-welcome-popup-close]');
    if (closeButton) closeButton.addEventListener('click', closePopup);
    if (backdrop) backdrop.addEventListener('click', closePopup);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePopup();
    });

    // On desktop (>=990px) this theme scrolls a nested `.page-wrapper`, not the document,
    // so wheel input over our fixed overlay never reaches it natively. Forward it manually.
    var desktopScrollQuery = window.matchMedia('(min-width: 990px)');
    popup.addEventListener(
      'wheel',
      function (event) {
        if (!desktopScrollQuery.matches) return;
        var pageWrapper = document.querySelector('.page-wrapper');
        if (!pageWrapper) return;
        event.preventDefault();
        pageWrapper.scrollBy({ top: event.deltaY, left: event.deltaX });
      },
      { passive: false }
    );

    setTimeout(function () {
      sessionStorage.setItem(storageKey, 'true');
      popup.classList.add('is-visible');
    }, delay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWelcomePopup);
  } else {
    initWelcomePopup();
  }

  } catch(e) { console.error(e); }
})();
})();
